var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var TableHeader = function (_a) {
    var columns = _a.columns, onHeaderClick = _a.onHeaderClick;
    return (_jsx("thead", { children: _jsx("tr", { children: columns.map(function (column, columnIndex) { return (_jsx("th", __assign({ style: { width: column.width }, onClick: function () {
                    if (onHeaderClick)
                        onHeaderClick(column.key);
                } }, { children: column.title }), "table-head-cell-".concat(columnIndex))); }) }) }));
};
